<template>
  <div>
    <div class="">
      <ProductsBody
        v-if="content.success"
        :line-items="form.lineItems"
        v-on:update-line-items="form.lineItems = $event"
        v-on:update-is-valid="isValid = $event"
        :priceMarkUpOption="parseFloat(form.priceMarkUpOption)"
      />
    </div>
    <div class="bg-white mx-8 border-t sticky bottom-0 z-50">
      <ProductsFooter
        v-if="content.success"
        :line-items="form.lineItems"
        :discount="form.discount"
        :shipping="form.shipping"
        :include-discount-in-pdf="form.includeDiscountInPDF"
        v-on:update-discount="form.discount = parseFloat($event)"
        v-on:update-shipping="form.shipping = $event"
        v-on:update-include-discount-in-pdf="form.includeDiscountInPDF = $event"
        :use-proforma-invoice-format="form.useProformaInvoiceFormat"
        v-on:update-use-proforma-invoice-format="
          form.useProformaInvoiceFormat = $event
        "
        :priceMarkUpOption="parseFloat(form.priceMarkUpOption)"
        v-on:update-price-mark-up-option="form.priceMarkUpOption = parseFloat($event);"
        :forceDiscount="form.forceDiscount"
        v-on:update-force-discount="form.forceDiscount = $event;"
        :discount-options="quoteRecord.discount_options"
      />
      <div class="border-t">
        <div v-if="content.loading" class="grid grid-cols-3 gap-4 p-4">
          <content-placeholders
            class="col-span-1 flex items-center justify-start"
          >
            <content-placeholders-img class="w-full px-8 py-4" />
          </content-placeholders>
          <content-placeholders
            class="col-span-1 flex items-center justify-center"
          >
            <content-placeholders-img class="w-full px-8 py-4" />
          </content-placeholders>
          <content-placeholders
            class="col-span-1 flex items-center justify-end"
          >
            <content-placeholders-img class="w-full px-8 py-4" />
          </content-placeholders>
        </div>
        <div v-if="content.success" class="grid grid-cols-3 gap-4 p-4">
          <div class="col-span-1 flex items-center justify-start">
            <button
              @click.prevent="back()"
              :disabled="ui.loading || actions.back.ui.loading"
              class="py-4 px-8 rounded transition-all duration-500 ease-in-out transform hover:scale-95"
            >
              <template v-if="!actions.back.ui.loading">
                <span class="font-semibold text-gray-500">Back</span>
              </template>
              <template v-else>
                <LoadingSpinner
                  class="fill-current text-primary text-opacity-75 h-6 w-6"
                />
              </template>
            </button>
          </div>
          <div class="col-span-1 flex items-center justify-center">
            <button
              @click.prevent="save()"
              :disabled="ui.loading || actions.save.ui.loading"
              class="px-8 py-4 transition-all duration-500 ease-in-out transform hover:scale-95"
            >
              <template v-if="!actions.save.ui.loading">
                <p class="text-primary font-semibold leading-none">
                  Save and close
                </p>
              </template>
              <template v-else>
                <LoadingSpinner
                  class="fill-current text-primary text-opacity-75 inline-block h-6 w-6"
                />
              </template>
            </button>
          </div>
          <div class="col-span-1 flex items-center justify-end">
            <button
              @click.prevent="submit()"
              :disabled="ui.loading || actions.next.ui.loading"
              :class="{
                'bg-warmgrey-400': actions.next.ui.loading
              }"
              class="bg-primary px-8 py-4 rounded transition-all duration-500 ease-in-out transform hover:scale-95"
            >
              <template v-if="!actions.next.ui.loading">
                <p class="text-white font-semibold leading-none">Next</p>
              </template>
              <template v-else>
                <LoadingSpinner
                  class="fill-current text-white text-opacity-75 h-6 w-6"
                />
              </template>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import {
  updateQuote,
  fetchTestMethodComponents,
  addLineItem,
  addItemGroup,
  updateItemGroup,
  updateLineItem,
  deleteLineItem,
  deleteItemGroup
} from "~/api";
import { required } from "vuelidate/lib/validators";

import ProductsBody from "~/components/app/ProductsBody";
import ProductsFooter from "~/components/app/ProductsFooter";

export default {
  name: "Products",

  components: {
    ProductsBody,
    ProductsFooter
  },

  data() {
    return {
      content: {
        loading: false,
        success: false,
        error: null
      },

      ui: {
        loading: false,
        success: false,
        error: null
      },

      actions: {
        back: {
          ui: {
            loading: false
          }
        },
        save: {
          ui: {
            loading: false
          }
        },
        next: {
          ui: {
            loading: false
          }
        }
      },

      form: {
        lineItems: [],
        includeDiscountInPDF: false,
        discount: 0,
        shipping: 0,
        useProformaInvoiceFormat: false,
        priceMarkUpOption: 0,
        forceDiscount: 1
      },

      isValid: false
    };
  },

  validations: {
    form: {
      lineItems: {
        required
      }
    }
  },

  mounted() {
    this.init();
  },

  computed: {
    ...mapGetters({
      quoteId: "quoteForm/id",
      quoteRecord: "quoteForm/record"
    })
  },

  methods: {
    init() {
      this.content.loading = true;
      this.content.success = false;
      this.content.error = null;

      if (this.quoteRecord) {
        this.form.discount = parseFloat(this.quoteRecord.discount_percentage);
        //this.form.shipping = parseFloat(this.quoteRecord.shipping_amount);
        this.form.shipping = this.quoteRecord.shipping_items;

        /* console.log('parseInt(this.quoteRecord.force_discount)', parseInt(this.quoteRecord.force_discount))
        console.log('this.quoteRecord.include_discount_in_pdf', this.quoteRecord.include_discount_in_pdf) */
        if (parseInt(this.quoteRecord.force_discount) === 1) {
          this.form.includeDiscountInPDF =
          this.quoteRecord.include_discount_in_pdf == 1 ? true : false;
        } else {
          if (this.quoteRecord.line_items.length > 0) {
            let includeDiscountInPDF = true;
            this.quoteRecord.line_items.forEach(lineItem => {
              if (lineItem.discount > 0) {
                includeDiscountInPDF = false;
              }
            });
            this.form.includeDiscountInPDF = includeDiscountInPDF;
          }
        }

        this.form.useProformaInvoiceFormat =
          parseInt(this.quoteRecord.use_proforma_invoice_format) === 1
            ? true
            : false;
        this.form.priceMarkUpOption = this.quoteRecord.price_mark_up_option;
        this.form.forceDiscount = this.quoteRecord.force_discount;

        if (this.quoteRecord.line_items.length == 0) {
          if (this.quoteRecord.test_methods.length > 0) {
            let testMethodsProcessed = 0;
            this.form.lineItems = [];
            this.quoteRecord.test_methods.forEach(testMethod => {
              fetchTestMethodComponents(testMethod.id)
                .then(response => {
                  let lineItems = this.parseLineItemsFromTestMethodComponents(
                    response,
                    testMethod
                  );
                  this.form.lineItems = this.form.lineItems.concat(lineItems);
                })
                .finally(() => {
                  testMethodsProcessed++;
                  if (
                    testMethodsProcessed ===
                    this.quoteRecord.test_methods.length
                  ) {
                    this.content.success = true;
                    this.content.loading = false;
                  }
                });
            });
            /*
            fetchTestMethodComponents(this.quoteRecord.test_methods[0].id)
              .then(response => {
                this.form.lineItems = this.parseLineItemsFromTestMethodComponents(
                  response
                );
              })
              .finally(() => {
                this.content.success = true;
                this.content.loading = false;
              });
            */
          } else {
            this.content.success = true;
            this.content.loading = false;
          }
        } else {
          this.form.lineItems = this.parseLineItems(
            this.quoteRecord.line_items
          );

          this.content.success = true;
          this.content.loading = false;
        }
        //this.content.loading = false;
        //this.content.success = true;
      } else {
        this.content.loading = false;
        this.content.success = true;
      }
    },

    parseLineItems(data) {
      return _.chain(data)
        .groupBy(item => item.item_group_id)
        .map(items => {
          let group = items[0].group;
          let lineItems = _.map(items, item => {
            /* console.log('item.product.additional_description', item.product.additional_description) */
            return {
              ...item,
              description: item.product.additional_description ? item.product.additional_description.replace('\n', '<br>') : '',
              is_deleted: false,
            };
          });
          return {
            ...group,
            test_method_name: null,
            is_deleted: false,
            is_expanded: true,
            items: lineItems
          };
        })
        .value();
    },

    parseLineItemsFromTestMethodComponents(data, testMethod) {
      const priceStructure = this.quoteRecord.price_structure;
      console.log('priceStructure', priceStructure)
      return _.chain(data)
        .groupBy(item => item.group_id)
        .map(components => {
          let group = components[0].group;
          let items = _.map(components, item => {
            let unitPrice = this.quoteRecord.type == "Domestic"
                  ? item.product.domestic_price
                  : item.product.international_price

            let discount = 0;
            let discount_is_custom = 0;
            let discount_forced = null;
            let discount_calculated = null;

            if (priceStructure) {
              if (item.product.product_discount_options.length > 0) {
                const findProductDiscount = item.product.product_discount_options.find(
                  productDiscount => productDiscount.discount_option_id == parseInt(priceStructure)
                );
                /* console.log('findProductDiscount', findProductDiscount) */
                if (findProductDiscount) {
                  if (priceStructure == 5) {
                    const find1A = item.product.product_discount_options.find(
                      productDiscount => productDiscount.discount_option_id == 2
                    );

                    if (find1A) {
                      const discount1N = ((1 - (parseFloat(find1A.discount_value) / 100)) / 0.65 / (1 - (parseFloat(findProductDiscount.discount_value) / 100)));
                      unitPrice = unitPrice * discount1N

                      if (parseFloat(unitPrice) > parseInt(unitPrice)) {
                        unitPrice = parseInt(unitPrice) + 1
                      }

                      discount = this.quoteRecord.discount_options.percentage_force

                    }
                  } else {
                    discount = parseFloat(findProductDiscount.discount_value);
                    console.log('discount', discount)
                  }
                }
              }
            }

            if (item.product.id == 16071) {
                      console.log('find1A', {
                        discount,
              discount_is_custom,
              discount_forced,
              discount_calculated,
              unitPrice,
              quantity: item.quantity,
              id: item.product.id,
                      })
                    }
            
            return {
              id: null,
              item_group_id: null,
              product_id: item.product.id,
              product: item.product,
              quote_id: this.quoteId,
              name: item.product.description,
              description: item.product.additional_description ? item.product.additional_description.replace('\n', '<br>').replace('\r', '<br>') : '',
              part_number: item.product.part_number,
              unit_price: unitPrice,
              quantity: item.quantity,
              discount: discount,
              discount_is_custom: discount_is_custom,
              discount_forced: discount_forced,
              discount_calculated: discount_calculated,
              active: true,
              is_deleted: false
            };
          });

          return {
            id: null,
            test_method_group_id: group.id,
            name: group.name,
            label: group.name,
            order: components.length > 0 ? components[0].order : null,
            test_method_name: testMethod.name,
            is_deleted: false,
            is_expanded: true,
            items
          };
        })
        .value();
    },

    validate() {
      return new Promise((resolve, reject) => {
        if (!this.isValidForm("form")) {
          reject("Missing fields.");
          return;
        }
        resolve("All fields have been validated in Customer Information.");
      });
    },

    async submit() {
      console.log('this.form.lineItems', this.form.lineItems)
      try {
        this.actions.next.ui.loading = true;
        this.ui.loading = true;
        this.ui.success = false;
        this.ui.error = null;

        
        // if (!this.isValid) {
        //   return;
        // }
       
        await this.updateQuote();
        await this.next();

        setTimeout(() => {
          this.ui.success = true;
        }, 3000);
      } catch (e) {
        console.error(e);
        this.ui.error = e;
      } finally {
        setTimeout(() => {
          this.ui.loading = false;
          this.actions.next.ui.loading = false;
        }, 3000);
      }
    },

    async updateQuote() {
      try {
        for (let i = 0, j = 0; i < this.form.lineItems.length; i++) {
          let group = this.form.lineItems[i];
          if (!group.id && group.is_deleted === false) {
            let itemGroup = this.form.lineItems[i];
            let response = await addItemGroup({
              label: itemGroup.label,
              name: itemGroup.name,
              test_method_group_id: itemGroup.test_method_group_id,
              order: j
            });
            group.id = response.id;
            j++;
          }

          if (group.id && group.is_deleted === false) {
            await updateItemGroup(group.id, {
              name: group.name,
              label: group.label,
              order: j
            });
            j++;
          }

          for (
            let index = 0;
            index < this.form.lineItems[i].items.length;
            index++
          ) {
            let item = this.form.lineItems[i].items[index];
            try {
              if (item.id) {
                if (item.is_deleted == true || group.is_deleted == true) {
                  await deleteLineItem(item.id);
                } else {
                  await updateLineItem(item.id, {
                    ...item,
                    item_group_id: group.id,
                    order: index
                  });
                }
              } else {
                if (item.is_deleted == false) {
                  await addLineItem({
                    ...item,
                    item_group_id: group.id,
                    order: index
                  });
                }
              }
            } catch (e) {
              console.error(e);
            }
          }

          if (group.id && group.is_deleted == true) {
            await deleteItemGroup(group.id);
          }
        }

        await updateQuote(this.quoteId, {
          discount_percentage: this.form.discount,
          //shipping_amount: this.form.shipping,
          shipping_items: this.form.shipping,
          include_discount_in_pdf: this.form.includeDiscountInPDF,
          use_proforma_invoice_format: this.form.useProformaInvoiceFormat,
          price_mark_up_option: this.form.priceMarkUpOption,
          force_discount: this.form.forceDiscount
        });
      } catch (error) {
        console.error(error);
      }
    },

    back() {
      window.SwalWarning.fire({
        title: "Are you sure?",
        text:
          "If you go back you will lose all your progress in the Products step."
      }).then(async result => {
        try {
          this.actions.back.ui.loading = true;
          this.ui.loading = true;
          if (result.value) {
            this.ui.success = false;
            this.ui.error = null;

            await this.deleteLineItems();

            setTimeout(() => {
              this.ui.success = true;

              this.$router.push({
                name: "quote.terms",
                params: { id: this.quoteId }
              });
            }, 3000);
          }
        } catch (e) {
          console.error(e);
          this.ui.error = e;
        } finally {
          setTimeout(() => {
            this.ui.loading = false;
            this.actions.back.ui.loading = false;
          }, 3000);
        }
      });
    },

    async deleteLineItems() {
      try {
        for (let i = 0; i < this.form.lineItems.length; i++) {
          let group = this.form.lineItems[i];

          for (let index = 0; index < group.items.length; index++) {
            let item = group.items[index];
            if (item.id) {
              await deleteLineItem(item.id);
            }
          }

          if (group.id) {
            await deleteItemGroup(group.id);
          }
        }

        this.form.lineItems = [];
      } catch (error) {
        console.error(error);
      }
    },

    async save() {
      try {
        this.actions.save.ui.loading = true;
        this.ui.loading = true;
        this.ui.success = false;
        this.ui.error = null;

        //await this.validate();
        await this.updateQuote();
        await this.close();

        setTimeout(() => {
          this.ui.success = true;
        }, 3000);
      } catch (e) {
        this.ui.error = e;
      } finally {
        this.ui.loading = false;
        this.actions.save.ui.loading = false;
      }
    },

    close() {
      window.Swal.fire({
        position: "top-end",
        icon: "success",
        title: "Your progress has been saved.",
        text: "Now it's safe to close this window.",
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      });
    },

    next() {
      setTimeout(() => {
        this.$router.push({
          name: "quote.summary",
          params: { id: this.quoteId }
        });
      }, 1500);
    }
  }
};
</script>

<style lang="scss" scoped>
.vue-content-placeholders-img {
  @apply h-12;
}
.vue-content-placeholders-img#text-area {
  @apply h-16;
}
.vue-content-placeholders-img.button {
  @apply w-56;
}
</style>
